<template>
	<div class="upload-input">
		<input id="id" type="file" ref="input" @change="handleChange" />
		<span v-show="error">{{ error }}</span>
	</div>
</template>

<script>
export default {
	props: ["value", "error", "id"],
	methods: {
		handleChange() {
			this.$emit("input", this.$refs.input.files[0]);
		}
	}
};
</script>

<style>
</style>